import React from 'react';
import { Race } from '../types/race';
import RaceCard from './RaceCard';

import './RaceGrid.css';

interface RaceGridProps {
  isLoading: boolean;
  isError: boolean;
  races: Race[];
}

const RaceGrid: React.FC<RaceGridProps> = ({ races, isLoading, isError }) => {
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading races...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-lg text-red-500">Failed to load races</div>
      </div>
    );
  }

  if (!races.length) {
    return (
      <div className="race-grid-container">
        <div className="race-grid-empty">
          <p>No races found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="race-grid-container">
      <div className={`race-grid grid-view`}>
        {races.map(race => (
          <div key={race.id} className="race-grid-item">
            <RaceCard race={race} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RaceGrid;
